export enum JobListingStatus{
  ACTIVE,
  SCHEDULED,
  CANCELLED,
  TERMINATED,
  DELETED,
}
